import { WorkflowStep } from "../types/maskWorkflow";

/**
 * Calculates the correct status for workflow steps based on completion status
 * Rules:
 * 1. Step completion is determined by the isCompleted property passed in
 * 2. The first uncompleted step is marked as 'current'
 * 3. All steps after the current step are 'locked'
 * 4. Steps before current can be completed or not completed
 */
export function calculateStepStatuses(steps: WorkflowStep[]): WorkflowStep[] {
  // First, reset current and locked states while preserving completion status
  const stepsWithCompletion = steps.map((step) => ({
    ...step,
    isCurrent: false,
    isLocked: false,
  }));

  // Find the first non-completed step - this becomes the current step
  let currentStepIndex = -1;
  for (let i = 0; i < stepsWithCompletion.length; i++) {
    if (!stepsWithCompletion[i].isCompleted) {
      currentStepIndex = i;
      break;
    }
  }

  // If all steps are completed, no step is current
  if (currentStepIndex === -1) {
    return stepsWithCompletion;
  }

  // Set the current step and lock all subsequent steps
  return stepsWithCompletion.map((step, index) => ({
    ...step,
    isCurrent: index === currentStepIndex,
    isLocked: index > currentStepIndex,
  }));
}
